import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AccountRegistrationPageComponent } from './shared/components/account-registration-page/account-registration-page.component';

const routes: Routes = [
    {
        path: '',
        redirectTo: 'adminselfregistration',
        pathMatch: 'full'
    },
    {
        path: 'register',
        component: AccountRegistrationPageComponent,
        title: 'Account Registration'
    },
    {
        path: 'adminselfregistration',
        // eslint-disable-next-line max-len
        loadChildren: () => import('./admin-self-registration/admin-self-registration.module').then(m => m.AdminSelfRegistrationModule),
        title: 'Administrator Account Registration'
    },
    {
        path: 'teacherselfregistration',
        // eslint-disable-next-line max-len
        loadChildren: () => import('./teacher-self-registration/teacher-self-registration.module').then(m => m.TeacherSelfRegistrationModule),
        title: 'Teacher Account Registration'
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})

export class AppRoutingModule { }
